import {DelegateModel} from '../../team/models/delegate.model';

export class ProgramDelegateModel {
    id: number;
    program: ProgramModel;
    delegate: DelegateModel;
    attend: boolean;
    attend_need: boolean; // tslint:disable-line:variable-name
    del_obj: ProgramTextareaModel; // tslint:disable-line:variable-name
    man_obj: ProgramTextareaModel; // tslint:disable-line:variable-name
    trainer_comments: ProgramTextareaModel; // tslint:disable-line:variable-name
    del_act_outcomes: ProgramTextareaModel; // tslint:disable-line:variable-name
    man_act_outcomes: ProgramTextareaModel; // tslint:disable-line:variable-name
    accreditations: ProgramAccreditationModel[];
    feedback: {
        company: ProgramFeedbackModel[];
        training: ProgramFeedbackModel[];
        comment1: ProgramTextareaModel; // tslint:disable-line:variable-name
        comment2: ProgramTextareaModel; // tslint:disable-line:variable-name
        comment3: ProgramTextareaModel; // tslint:disable-line:variable-name
    }
    scan_file: string; // tslint:disable-line:variable-name
}

export class ProgramDelegateSimpleModel {
    id: number;
    program: ProgramSimpleModel;
    attend: boolean;
    attend_need: boolean; // tslint:disable-line:variable-name
}

export class ProgramModel {
    id: number;
    uid: number;
    program_dates: string; // tslint:disable-line:variable-name
    program_date_from: string; // tslint:disable-line:variable-name
    program_date_till: string; // tslint:disable-line:variable-name
    time: string;
    venue: ProgramVenueModel;
    title: string;
    intro: string;
    deadline1: string;
    deadline3: string;
    deadline4: string;
    deadline5: string;
}

export class ProgramSimpleModel {
    id: number;
    uid: number;
    program_dates: string; // tslint:disable-line:variable-name
    program_date_from: string; // tslint:disable-line:variable-name
    program_date_till: string; // tslint:disable-line:variable-name
    time: string;
    venue: ProgramVenueModel;
    title: string;
}

export class ProgramVenueModel {
    id: number;
    name: string;
    contact_name: string; // tslint:disable-line:variable-name
    email: string;
    addr1: string;
    addr2: string;
    addr3: string;
    addr4: string;
    post: string;
}

export class ProgramAccreditationModel {
    id: number;
    score: number;
    pass: {
        value: string;
        output: string;
        style: {
            class: string;
        };
    };
    date: string;
    comments: string;
    title: string;
}

export class ProgramFeedbackModel {
    id: number;
    title: string;
    value: number;
}

export class ProgramTextareaModel {
    value: string;
    output: string;
}

export class MyDiaryUpdateRequestModel {
    pr_del_id: number; // tslint:disable-line:variable-name
    del_obj: string; // tslint:disable-line:variable-name
    del_act_outcomes: string; // tslint:disable-line:variable-name
    feedback: {
        company: ProgramFeedbackModel[];
        training: ProgramFeedbackModel[];
        comment1: ProgramTextareaModel; // tslint:disable-line:variable-name
        comment2: ProgramTextareaModel; // tslint:disable-line:variable-name
        comment3: ProgramTextareaModel; // tslint:disable-line:variable-name
    };
}

export class UserDiaryUpdateRequestModel {
    pr_del_id: number; // tslint:disable-line:variable-name
    man_obj: string; // tslint:disable-line:variable-name
    man_act_outcomes: string; // tslint:disable-line:variable-name
}
